<template>
  <div class="plan-container my-4 w-100" :style="cssVariables">
    <div
      class="title-container"
      :style="{
        color: backgroundImage ? '#FFF' : 'var(--terciary-color)'
      }"
    >
      <img v-if="iconImage" :src="iconImage" width="25" class="mb-1" />
      <p class="name">{{ name }}</p>
      <p class="description">{{ description }}</p>
    </div>

    <div class="d-flex flex-column justify-content-center specs-container">
      <div v-for="(s, i) in specs || []" :key="i" class="row mt-2">
        <b-col v-if="s.active" cols="1">
          <i
            class="ph-bold ph-check"
            :style="{ fontSize: '20px', color: 'var(--terciary-color)' }"
          ></i>
        </b-col>
        <b-col v-if="s.active" class="text-left spec">
          {{ s.title }}
        </b-col>
      </div>
    </div>

    <div class="purchase-container">
      <p v-if="renderOriginalCost" class="original-cost m-0">
        {{ currencySymbol }}{{ Math.ceil(originalCostWithoutDiscount) }}
      </p>
      <p class="cost">
        <span class="currency">
          {{ currencySymbol }}
        </span>
        <span>
          {{ price }}
        </span>
      </p>
      <div class="button-container w-75 mb-1">
        <Button
          shape="full"
          width="full"
          :enabled="upgrade"
          text="white"
          :with-gradient="true"
          gradient="var(--primary-color)"
          @click="$emit('subscribe')"
          >{{ buttonText }}</Button
        >
      </div>
      <p v-if="priceDescription" class="description text-center">{{ priceDescription }}</p>
    </div>
  </div>
</template>

<script>
import Button from 'UI/Button';
export default {
  components: {
    Button
  },
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    currencySymbol: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    priceDescription: {
      type: String,
      required: true
    },
    originalCostWithoutDiscount: {
      type: Number,
      required: true
    },
    discount: {
      type: Number,
      required: true
    },
    upgrade: {
      type: Boolean,
      required: true
    },
    primaryColor: {
      type: String,
      required: true
    },
    secondaryColor: {
      type: String,
      required: true
    },
    terciaryColor: {
      type: String,
      required: true
    },
    quaternaryColor: {
      type: String,
      required: true
    },
    backgroundImage: {
      type: String,
      required: false,
      default: ''
    },
    buttonText: {
      type: String,
      required: true
    },
    iconImage: {
      type: String,
      required: false,
      default: ''
    },
    specs: {
      type: Array,
      required: true
    }
  },
  computed: {
    cssVariables() {
      return `
        --primary-color: ${this.primaryColor};
        --secondary-color: ${this.secondaryColor};
        --terciary-color: ${this.terciaryColor};
        --quaternary-color: ${this.quaternaryColor};

        --background-image: url(${this.backgroundImage});
        --border-color: ${!this.backgroundImage ? '3px solid var(--secondary-color)' : 'none'}
      `;
    },
    renderOriginalCost() {
      return this.discount && this.originalCostWithoutDiscount && this.currencySymbol;
    }
  }
};
</script>

<style lang="scss" scoped>
.plan-container {
  display: grid;
  grid-template-columns: 1fr;
  padding-bottom: 25px;
  @include min-lg {
    padding-bottom: 0px;
    grid-template-columns: 1fr 1.5fr 1fr;
  }
  grid-template-rows: 1fr;
  grid-column-gap: 50px;
  grid-row-gap: 0px;
  border-radius: 20px;
  overflow: hidden;
  min-height: 230px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  min-width: 250px;
  color: var(--terciary-color);
  background-color: var(--quaternary-color);
  border: 3px solid var(--secondary-color);
  .title-container {
    justify-content: start;
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 40px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    max-width: min-content;
    background-image: var(--background-image);
    border-right: none;
    @include min-lg {
      border-right: var(--border-color);
    }
    @include lg {
      align-items: center;
      padding: 40px 20px 10px;
      flex: 0 0 100%;
      max-width: 100%;
    }
    .name {
      font-size: 38px;
      line-height: 40px;
      text-align: left;
      margin-bottom: 5px;
      @include lg {
        text-align: center;
      }
    }
    .description {
      font-size: 11px;
      @include min-lg {
        white-space: nowrap;
        text-align: left;
      }
    }
  }
  .specs-container {
    @include lg {
      flex: 0 0 100%;
      max-width: 100%;
      padding: 1.5em 1em;
      order: 1;
      margin: 0;
    }

    .spec {
      font-size: 13px;
      display: flex;
      align-items: center;
    }
  }
  .purchase-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .original-cost {
      text-decoration: line-through;
      text-align: center;
      filter: opacity(0.5);
    }
    .currency {
      font-size: 26px;
      padding-right: 0.2em;
    }
    .cost {
      justify-content: center;
      margin-bottom: 0;
      display: flex;
      font-size: 60px;
      line-height: 1.2em;
    }
    .description {
      margin: 0.5em;
      filter: opacity(0.5);
    }
  }
}
</style>
